<script>
    import I18n from '@js/modules/translations';
    import AnalyticsService from '@js/modules/analyticsService';

    import {mapStore} from '@js/stores/mapStore';

    // Route-generation mode chosen before drawing — mirrors the store so the map stays in sync. One active
    // at a time so it's clear what's on. The reachable zone and the loop are set up from their own panel
    // on the map (PlannerMapExtras).
    const mode = $derived($mapStore.plannerMode);

    // Selecting the active mode again toggles back to free drawing. The reachable zone keeps the route:
    // it is computed around the start point already on the map.
    const _selectMode = (next) => {
        const target = next === mapStore.plannerMode ? 'free' : next;

        mapStore.plannerMode = target;
        AnalyticsService.trackPlannerModeSelected(target);

        // Isochrone is drawn from the store (its panel picks the value); drop it whenever we leave that mode.
        if (target !== 'isochrone') {
            mapStore.isochroneType = null;
            mapStore.isochroneValue = 0;
        }

        // The mode is used on the map, where its panel is: bring it into view.
        document.getElementById('planner-map-container')?.scrollIntoView({behavior: 'smooth', block: 'start'});
    };

    const MODES = [
        {key: 'free', icon: 'M3,3H21V5H3V3M3,7H15V9H3V7M3,11H21V13H3V11M3,15H15V17H3V15M3,19H21V21H3V19Z'},
        {key: 'isochrone', icon: 'M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7Z'},
        {key: 'loop', icon: 'M12,4C14.1,4 16.1,4.8 17.6,6.3C20.7,9.4 20.7,14.5 17.6,17.6C15.8,19.5 13.3,20.2 10.9,19.9L11.4,17.9C13.1,18.1 14.9,17.5 16.2,16.2C18.5,13.9 18.5,10.1 16.2,7.7C15.1,6.6 13.5,6 12,6V10.6L7,5.6L12,0.6V4M6.3,17.6C3.7,15 3.3,11 5.1,7.9L6.6,9.4C5.5,11.6 5.9,14.4 7.8,16.2C8.3,16.7 8.9,17.1 9.6,17.4L9,19.4C8,19 7.1,18.4 6.3,17.6Z'}
    ];
</script>

<div class="planner-route-options mx-auto mb-6 w-[94%] max-w-4xl rounded-xl bg-white px-4 py-3 block-shadow-xl md:px-6">
    <span class="mb-2 block text-xs font-bold uppercase tracking-wide text-gray-500">
        {I18n.t('js.maps.planner_options.title')}
    </span>

    <!-- Exclusive mode selector: free draw / reachable zone / loop -->
    <div class="flex flex-wrap gap-2" role="group" aria-label={I18n.t('js.maps.planner_options.title')}>
        {#each MODES as item (item.key)}
            <button type="button"
                    class="inline-flex items-center gap-2 rounded-lg border px-3 py-2 text-sm font-semibold transition-colors"
                    class:border-primary-600={mode === item.key}
                    class:bg-primary-50={mode === item.key}
                    class:text-primary-700={mode === item.key}
                    class:border-gray-200={mode !== item.key}
                    class:bg-white={mode !== item.key}
                    class:text-gray-600={mode !== item.key}
                    aria-pressed={mode === item.key}
                    onclick={() => _selectMode(item.key)}>
                <svg class="h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d={item.icon}/>
                </svg>
                {I18n.t(`js.maps.planner_options.${item.key}`)}
            </button>
        {/each}
    </div>
</div>
